"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Star = _interopRequireDefault(require("../../icons-react/rebrand/Star"));
var starsMetaProps = {
  itemProp: 'starRating',
  itemScope: true,
  itemType: 'https://schema.org/Rating'
};
var HotelStars = function HotelStars(_ref) {
  var className = _ref.className,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 1 : _ref$gap,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 14 : _ref$size,
    value = _ref.value,
    showMeta = _ref.showMeta;
  var startArr = !(0, _isNil2["default"])(value) ? Array.from(Array(value).keys()) : [];
  var metaProps = showMeta ? starsMetaProps : {};
  return !(0, _isEmpty2["default"])(startArr) ? /*#__PURE__*/_react["default"].createElement(StyledHotelStars, (0, _extends2["default"])({
    className: className,
    gap: gap
  }, metaProps), showMeta ? /*#__PURE__*/_react["default"].createElement("meta", {
    itemProp: "ratingValue",
    content: String(value)
  }) : null, startArr.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(StyledStarIcon, {
      key: item,
      height: size
    });
  })) : null;
};
var StyledStarIcon = (0, _styledComponents["default"])(_Star["default"]).withConfig({
  displayName: "HotelStars__StyledStarIcon",
  componentId: "sc-1tt0th8-0"
})(["path{fill:var(--secondary);}"]);
var StyledHotelStars = _styledComponents["default"].div.withConfig({
  displayName: "HotelStars__StyledHotelStars",
  componentId: "sc-1tt0th8-1"
})(["display:flex;flex-direction:row;gap:", "px;"], function (props) {
  return props.gap;
});
var _default = exports["default"] = HotelStars;